import React from 'react';

import {MainTitle} from './MainTitle.jsx';
import {ThemeName} from './ThemeName.jsx';
import {ActivateButton} from './ActivateButton.jsx';
import {ShareCloneTransferButtonSet} from './ShareCloneTransferButtonSet.jsx';
import {HeaderRightButtons} from './HeaderRightButtons.jsx';

var Header = React.createClass({
  getInitialState: function(){
    return {
      url: "?page=Onboard"
    }
  },
  clone: function(action){
    this.props.clone(action);
  },
  sharePackage: function(action){
    this.props.sharePackage(action);
  },
  transferPackage: function(action){
    this.props.transferPackage(action);
  },
  snapshot: function(action){
    this.props.snapshot(action);
  },
  showPreview: function(){
      this.props.showPreview();
  },
  editTheme: function(slug, accountSlug){
      this.props.editTheme(slug, accountSlug);
  },
  openSource: function(){
      this.props.openSource();
  },
  makeActive: function(slug){
      this.props.makeActive(slug);
  },
	handlePullClick:  function () {
      $('.site__nav-dropdown').toggle(); // closes dropdown when click on pull
      // if(localStorage.getItem("session_key") === null){
      //   window.location.href = this.state.url;
      // } else {
        var fullyQualifiedName =  this.props.data["name"];
        this.props.pull(fullyQualifiedName);      
      // }
	},
  handlePushClick: function(){
      $('.site__nav-dropdown').toggle(); // closes dropdown when click on push
      // if(localStorage.getItem("session_key") === null){
      //   window.location.href = this.state.url;
      // } else {
        var fullyQualifiedName =  this.props.data["name"];
        this.props.push(fullyQualifiedName);      
      // }
  },
  handleInstallClick: function(){
      $('.site__nav-dropdown').toggle(); // closes dropdown when click on install
      // this.props.install(this.props.slug);
      // if(localStorage.getItem("session_key") === null){
      //   window.location.href = this.state.url;
      // } else {
        var fullyQualifiedName =  this.props.data["name"];
        this.props.popup(fullyQualifiedName, "install");
      // }
  },
  popup: function(value, action){
      this.props.popup(value, action);
  },
  handleCloneByVersionClick: function(){
      $('.site__nav-dropdown').toggle(); // closes dropdown when click on push
      this.props.cloneByVersionPopup(true);
  },
  handlePullByVersionClick: function(){
      $('.site__nav-dropdown').toggle(); // closes dropdown when click on push
      this.props.pullByVersion(true);
  },
  updatePackage: function(action){
      $('.site__nav-dropdown').toggle();
      this.props.updatePackage("open");
  },
  render: function(){
    var button;
    if(this.props.type !== "VIEWLAYOUT" && this.props.libName != "Shared with me" && this.props.libName != "Pending Transfers"){
      button = <ActivateButton value = {this.props.data}
                                slug = {this.props.slug}
                                makeActive = {this.makeActive}
                                active = {this.props.active}
                                popup = {this.popup}
                                slug = {this.props.slug}
                                account = {this.props.account}
                                type = {this.props.type} />;
    } else if (this.props.libName == "Shared with me"){
      button = <CloneButton clone = {this.clone}/>;
    } else if(this.props.libName === "Pending Transfers") {
      button = <RevokeTransfer />;
    } else {
      button = <li />;
    }

    var buttonset = null;
    if(this.props.libName !== "Shared with me" && this.props.libName !== "Pending Transfers"){
      buttonset = <ShareCloneTransferButtonSet  data = {this.props.data}
                                                clone = {this.clone}
                                                sharePackage = {this.sharePackage}
                                                transferPackage = {this.transferPackage}
                                                snapshot = {this.snapshot}
                                                slug = {this.props.slug}
                                                handlePullClick = {this.handlePullClick} 
                                                handlePushClick = {this.handlePushClick}
                                                handleInstallClick = {this.handleInstallClick}
                                                active = {this.props.active}
                                                aquisitions = {this.props.aquisitions}
                                                handleCloneByVersionClick = {this.handleCloneByVersionClick}
                                                handlePullByVersionClick = {this.handlePullByVersionClick}
                                                account = {this.props.account}
                                                updatePackage = {this.updatePackage} />;
    } else if(this.props.libName === "Pending Transfers"){
      buttonset = null;
    } else if(this.props.libName === "Shared with me") {
      buttonset = <CloneButtonSet handleCloneByVersionClick = {this.handleCloneByVersionClick}
                                  handleInstallClick = {this.handleInstallClick} />
    }

    return(
        <div className="header">
        <div className="content-header">
          <div className="content__col content__col--left">
           <MainTitle />
            <div className="site__nav">
              <ul>
              	<ThemeName themeName = {this.props.val} />

                {button}

                {buttonset}
              </ul>
            </div>
          </div>
          <div className="content__col content__col--right">
          <HeaderRightButtons data = {this.props.data}
                              editTheme = {this.editTheme}
                              showPreview = {this.showPreview}
                              openSource = {this.openSource}
                              aquisitions = {this.props.aquisitions}
                              libName = {this.props.libName}
                              type = {this.props.type} />
          </div>
        </div>
      </div>
      );
  }
});

var CloneButton = React.createClass({
  handleCloneClick: function(){
    this.props.clone("open");
  },
  render: function(){
    return(
      <li onClick = {this.handleCloneClick}>
        <a href="javascript:void(0)"><i className ="fa  fa-clone"></i> Clone</a>
      </li>
      );
  }
});

var CloneButtonSet = React.createClass({
  componentDidMount: function(){
    $(document).click(function(e){
      var $clicked = $(e.target);
        if ($clicked.closest('.site__nav').length < 1) {
          $('.site__nav-dropdown').hide();
        }
    });
  },
  handleCloneByVersionClick: function(){
    alert("Coming soon");
  },
  handleInstallClick: function(){
    alert("Coming soon");
  },
  handleClick: function(e){
    $(".site__nav-dropdown").toggle();
  },
  render: function(){
    return (
      <ul>
        <li onClick = {this.handleClick}><a href="javascript:void(0)" className="site__nav-toggle"><i className="fa  fa-chevron-circle-down"></i></a>
          {/*<ul className="site__nav-dropdown" onClick = {this.handleClick}>
            <li className="tooltip__container" onClick = {this.props.handleCloneByVersionClick}><a href="javascript:void(0)"><i className="fa fa-copy"> </i> Clone by Version</a><span className="tooltip tooltip--left tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
            <li className="tooltip__container" onClick = {this.props.handleInstallClick}><a href="javascript:void(0)"><i className="fa  fa-cogs"> </i> Install</a><span className="tooltip tooltip--left tooltip--sm">Lorem Ipsum is simply dummy text of the printing and typesting industry. Lorem IpsLorem Ipsum is simply dummy text of the printing and typesing industry. </span></li>
          </ul>*/}
        </li>
      </ul>
      );
  }
});

var AcceptTransfer = React.createClass({
  render: function(){
    return (
        <li className="active__btn">
          <a href="javascript:void(0)">Accept Transfer</a>
        </li>
      );
  }
});

var RevokeTransfer = React.createClass({
  render: function(){
    return (
      <li className="revoke_btn">
        <a href="javascript:void(0)">Revoke Transfer</a>
      </li>
      )
  }
})

export {Header};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/Header.jsx
 **/